import React, { useState } from 'react';
import { Button, Flex, Modal, Spin, Tooltip } from 'antd';
import { EyeOutlined } from '@ant-design/icons';
import { _T } from '../src/Localization';
import { getUrl } from '../scripts/cdn';
export const TeamImagePreviewButton = ({ imageId }) => {
    const [open, setOpen] = useState(false);
    const [loading, setLoading] = useState(false);
    if (imageId == null || imageId === '' || imageId === 0 || imageId === '0') {
        return null;
    }
    const normalizedImageId = String(imageId);
    return (React.createElement(React.Fragment, null,
        React.createElement(Tooltip, { title: _T('common.image') },
            React.createElement(Button, { type: "text", size: "small", icon: React.createElement(EyeOutlined, null), onClick: (event) => {
                    event.stopPropagation();
                    setLoading(true);
                    setOpen(true);
                } })),
        React.createElement(Modal, { open: open, footer: null, onCancel: () => {
                setOpen(false);
                setLoading(false);
            }, destroyOnHidden: true },
            loading && (React.createElement(Flex, { justify: "center", align: "center", style: { minHeight: 240 } },
                React.createElement(Spin, null))),
            React.createElement("img", { alt: _T('common.image'), style: {
                    width: '100%',
                    display: loading ? 'none' : 'block'
                }, src: getUrl(`pics/${normalizedImageId}/large`), onLoad: () => setLoading(false), onError: () => setLoading(false) }))));
};
export default TeamImagePreviewButton;
